import { atom, useAtom, getDefaultStore } from 'jotai'
import { matchAttribute } from '../helpers'

const categoryAttributesAtom = atom(null)

const useCategoryAttributes = () => {
  const [categoryAttributes, setCategoryAttributes] = useAtom(categoryAttributesAtom)

  const getCategoryAttributes = () => getDefaultStore().get(categoryAttributesAtom)

  const match = (attribute, isSpec = false) => {
    const data = getCategoryAttributes()
    if (!data) {
      return false
    }
    return matchAttribute(data, attribute, isSpec)
  }

  return {
    categoryAttributes,
    getCategoryAttributes,
    setCategoryAttributes,
    match
  }
}

export default useCategoryAttributes
export { matchAttribute } from '../helpers'
